import { Routes, Route } from 'react-router-dom'

import { Home } from '../pages/Home'
import { SignIn } from '../pages/SignIn'
import { SignUpCollaborator } from '../pages/SignUpCollaborator'
import { SignUpStudent } from '../pages/SignUpStudent'

import { Dashboard } from '../pages/Dashboard'
import { RegisterQuestion } from '../pages/RegisterQuestion'
import { RegisterQuestion2 } from '../pages/RegisterQuestion2'
import { Profile } from '../pages/Profile'
import { RegisterCategory } from '../pages/RegisterCategory'
import { Questions } from '../pages/Questions'

import { Private } from './Private'

export function RoutesApp() {
  return (
    <Routes>
      <Route path='/' element={<Home />} />
      <Route path='/login' element={<SignIn />} />
      <Route path='/questoes-publicas' element={<SignUpStudent />} />

      <Route path='/dashboard' element={<Private><Dashboard /></Private>} />
      <Route path='/cadastrar-questao' element={<Private><RegisterQuestion /></Private>} />
      <Route path='/cadastrar-questao/:id' element={<Private><RegisterQuestion /></Private>} />
      <Route path='/cadastrar-questao2' element={<Private><RegisterQuestion2 /></Private>} />
      <Route path='/perfil' element={<Private><Profile /></Private>} />
      <Route path='/cadastrar-categoria' element={<Private><RegisterCategory /></Private>} />
      <Route path='/cadastrar-colaborador' element={<Private><SignUpCollaborator /></Private>} />
      <Route path='/questoes' element={<Private><Questions /></Private>} />
    </Routes>
  )
}